import { Link } from "react-router-dom";
import type { Movie } from "@/types";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/movie/${movie.id}`}
      className="group flex flex-col rounded-lg bg-background-50 border border-background-200 p-3 hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] rounded-md overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} - 影视海报`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full text-xs font-label font-bold bg-primary-500 text-background-50">
          {movie.genre}
        </span>
        <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-full text-xs font-label bg-foreground-950/70 text-background-50 flex items-center gap-1">
          <i className="ri-fire-line text-accent-400"></i>
          {(movie.heat / 1000).toFixed(1)}k
        </div>
      </div>
      <div className="pt-3 flex-1 flex flex-col">
        <h3 className="font-heading text-base font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.region} · {movie.year} · {movie.duration}
        </p>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {movie.summary}
        </p>
      </div>
    </Link>
  );
}